import React from 'react';
import useDeprecationWarning from '@bubble-ui/hook-use-deprecation-warning';
var NODE_COMMENT = 8;
var COMMENT_START = 'MouseflowExcludeStart';
var COMMENT_END = 'MouseflowExcludeEnd';
var MouseflowExclude = function MouseflowExclude(_ref) {
  var children = _ref.children;
  useDeprecationWarning({
    componentName: '@bubble-contrib/support-mouseflow-exclude',
    removalDate: 'v5.0.0'
  });
  return /*#__PURE__*/React.createElement("span", {
    ref: function ref(span) {
      var firstChild = span && span.childNodes && span.childNodes[0];
      if (firstChild == null) {
        return;
      }
      if (firstChild.nodeType === NODE_COMMENT && firstChild.textContent === COMMENT_START) {
        return;
      }
      span.insertBefore(document.createComment(COMMENT_START), firstChild);
      span.appendChild(document.createComment(COMMENT_END));
    }
  }, children);
};
MouseflowExclude.displayName = 'MouseflowExclude';

/**
 * @deprecated this component is outdated and will be removed with v5.0.0
 */
export var exclude = function exclude(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(MouseflowExclude, null, /*#__PURE__*/React.createElement(Component, props));
  };
};

/**
 * @deprecated this component is outdated and will be removed with v5.0.0
 */
export default MouseflowExclude;
//# sourceMappingURL=index.js.map